import React from 'react';
import './TermsOfUse.css';
import Footer from '../../Components/Footer/Footer';
import TermsDescriptions from '../../Components/TermsDescriptions/TermsDescriptions';

function TermsOfUse() {
  return (
    <div className="termsOfUse-page-container">
      <TermsDescriptions />
      <Footer />
    </div>
  );
}

export default TermsOfUse;
